import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select, Tree } from 'antd';

export interface ICountryTreeProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  onChange: (e: any, countries: GQL.ICountry[] | undefined) => void;
  value: string[] | undefined;
  countries?: Array<GQL.ICountry>;
  hideRegions?: boolean;
  style?: any;
}

export class CountryTree extends React.PureComponent<ICountryTreeProps> {

  public static defaultProps = {
    hideRegions: true,
  };

  constructor(props: ICountryTreeProps) {
    super(props);
  }

  public render() {
    const { value, style, countries } = this.props;

    if (countries) {
      return (
        <Tree
          onCheck={(checkedKeys: any, info: any) => this.onChangeCountry(countries, checkedKeys.checked, info.node)}
          onSelect={(checkedKeys: any, info: any) => this.onChangeCountry(countries, checkedKeys, info.node)}
          selectedKeys={value}
          checkedKeys={value}
          multiple={true}
          checkable={true}
          checkStrictly={true}
          treeData={this.renderCountriesTree(countries, null)[0]}
        />
      );
    }

    return (
      <Select placeholder={'Choose country'} style={...style} />
    );
  }

  private renderCountriesTree(allCountries: Array<GQL.ICountry>, parentId: string | null) {
    const countries = allCountries.filter((country: GQL.ICountry) => country.parentCountryId === parentId);

    if (countries.length === 0) {
      return null;
    }

    return countries.map((country: GQL.ICountry) => {
      country.key = country.id;
      country.title = country.name
      if (parentId === null) {
        return this.renderCountriesTree(allCountries, country.id);
      }
      country.children = this.renderCountriesTree(allCountries, country.id)
      return (
          country
      );
    });
  }

  private onChangeCountry(allCountries: Array<GQL.ICountry>, value: any, node: any) {
    // id země, která byla ovlivněna
    const countryId = node.props.eventKey;
    // zaškrtnuta, odškrtnuta ?
    const checked = value.indexOf(countryId) !== -1;

    // zaškrtnuto
    if (checked) {
      // zaškrtnu podřízené země
      allCountries
        .filter((country: GQL.ICountry) => country.parentCountryId === countryId)
        .forEach((country: GQL.ICountry) => {
          if (value.indexOf(country.id) === -1) {
            value.push(country.id);
          }
        });
    }

    // odškrtnuta
    if (!checked) {
      // odškrtnu podřízené země
      allCountries
        .filter((country: GQL.ICountry) => country.parentCountryId === countryId)
        .forEach((country: GQL.ICountry) => {
          if (value.indexOf(country.id) > -1) {
            value.splice(value.indexOf(country.id), 1);
          }
        });
    }

    const countries = allCountries.filter((c: GQL.ICountry) => {
      return value.includes(c.id);
    });

    // vyberu podrizene
    this.props.onChange({
      target: {
        name: this.props.name,
        value,
      }
    }, countries);
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/CountryTree/CountryTree.tsx